var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.attributes.length > 1)?_c('div',[_c('Dropdown',{attrs:{"options":_vm.selectOptions,"label":_vm.label,"option-label":"label","placeholder":"Choose...","disabled":_vm.disabled,"small-label":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }